<template>
    <v-app dark id="MPCRoot" title="Main Content">
        <mpc-page-header></mpc-page-header>
        <main>
            <v-content>
                <router-view></router-view>
            </v-content>
        </main>
        <mpc-page-footer></mpc-page-footer>
    </v-app>
</template>
<script>
    import MPCHeader from "./components/MPCHeader";
    import MPCFooter from "./components/MPCFooter";
    export default {
        name: "MPCRoot",
        components: {
            'mpc-page-header' : MPCHeader,
            'mpc-page-footer' : MPCFooter,
        }
    }
</script>
